export const LOGIN = 'session/LOGIN';
export const LOGOUT = 'session/LOGOUT';
export const LOGIN_SUCCESS = 'session/LOGIN_SUCCESS';
export const LOGIN_ERROR = 'session/LOGIN_ERROR';
export const TRY_LOGIN = 'session/TRY_LOGIN';
export const RECOVER_PASSWORD = 'session/RECOVER_PASSWORD';
export const CHECK_AND_REQUEST_NOTIFICATION_PERMISSION = 'session/CHECK_AND_REQUEST_NOTIFICATION_PERMISSION';

export const CHANGE_OPERATOR_STATUS = 'session/CHANGE_OPERATOR_STATUS';
export const CHECK_IS_SHOULD_LOGOUT = 'session/CHECK_IS_SHOULD_LOGOUT';
export const UPDATE_SESSION = 'session/UPDATE';

export const logIn = (companyLogin, operatorLogin, operatorPasswordHash, shouldRemember) => ({
  type: LOGIN,
  payload: {
    companyLogin,
    operatorLogin,
    shouldRemember,
    operatorPasswordHash,
  },
});

export const loginSuccess = data => ({
  type: LOGIN_SUCCESS,
  payload: data,
});

export const loginError = error => ({
  type: LOGIN_ERROR,
  payload: error.name && error.description
    ? error
    : error.error && error.errorDescription
      ? {
        name: error.error,
        description: error.errorDescription,
      }
      : {
        name: error,
        description: error,
      },
})

export const tryLogin = (companyLogin, operatorLogin, operatorPassword, shouldRemember, isUseEmail) => ({
  type: TRY_LOGIN,
  payload: {
    companyLogin,
    operatorLogin,
    operatorPassword,
    shouldRemember,
    isUseEmail,
  },
});

export const checkAndRequestNotificationPermission = () => ({
  type: CHECK_AND_REQUEST_NOTIFICATION_PERMISSION,
});

export const recoverPassword = (companyLogin, operatorLogin, onSuccess, onError) => ({
  type: RECOVER_PASSWORD,
  payload: {
    companyLogin,
    operatorLogin,
    onSuccess,
    onError,
  },
})

export const logOut = ({ cachedState, isWaitBridgeConnection = true } = {}) => ({
  type: LOGOUT,
  payload: { cachedState, isWaitBridgeConnection },
});

export const updateSession = session => ({
  type: UPDATE_SESSION,
  payload: session,
});

export const checkIsShouldLogout = () => ({
  type: CHECK_IS_SHOULD_LOGOUT,
});

export const UPDATE_OPERATOR_PERMISSIONS = 'settings/UPDATE_OPERATOR_PERMISSIONS';
export const updateOperatorPermissions = permissions => ({
  type: UPDATE_OPERATOR_PERMISSIONS,
  payload: permissions,
})
